import com from '../../../../comMapping.js';
export function getdata() {
	let obj = {
		searchlist: [{
				prop: "felecInvoiceNo",
				label: '数电票号码',
				type: "input",
			},
			{
				prop: "docNo",
				label: '单据号',
				type: "input",
			},
			{
				prop: "invoiceStatus",
				label: '单据状态',
				type: "selectmore",
				selectval: [{
					value: '7',
					label: '开票失败'
				}, {
					value: '4',
					label: '已开票'
				}]
			},
			{
				prop: "processingStatus",
				label: '处理状态',
				type: "selectmore",
				selectval: [{
					value: '-1',
					label: '处理失败'
				}, {
					value: '0',
					label: '未处理'
				}, {
					value: '1',
					label: '处理中'
				}, {
					value: '2',
					label: '处理成功'
				}]
			},
			{
				prop: "invoiceType",
				label: '发票类型',
				type: "selectmore",
				selectval: com.fplx
			},
			{
				prop: "purchaserName",
				label: '购方名称',
				type: "input",
			},
			{
				prop: "drawDates",
				label: '开票时间',
				type: "datetimerange",
				valueformat: "yyyy-MM-dd HH:mm:ss"
			},
			{
				prop: "taxAmounts",
				label: "价税合计",
				type: "inputplus"
			},
			{
				prop: "taskBatchNo",
				label: '任务批次号',
				type: "input",
			},
			{
				prop: "executeDates",
				label: '最近操作时间',
				type: "datetimerange",
				valueformat: "yyyy-MM-dd HH:mm:ss"
			}
		],
		searchdata: {
			felecInvoiceNo: '',
			docNo: '',
			invoiceStatus: [],
			processingStatus: [],
			invoiceType: [],
			purchaserName: '',
			drawDates: [],
			taxAmounts: [],
			taskBatchNo: '',
			executeDates: [],
		}
	}
	return obj
}
